import { useQuery, useMutation, useQueryClient } from 'react-query'
import { endPoll, getPolls, startPoll } from '../api/polls'
import { type Poll, pollMapper } from '../models/poll'

/**
 * Get all polls for a webinar.
 *
 * @param {number} id The ID of the webinar
 */
export function usePollsQuery(id: string) {
  return useQuery(
    ['polls', id],
    async (): Promise<Poll[]> => {
      const mapper = pollMapper()
      return (await getPolls(id)).map(mapper.fromDto)
    },
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  )
}

export function useInvalidatePollsQuery(id: string): () => Promise<void> {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries(['polls', id])
}

export function useStartPollMutation(pollId: number) {
  return useMutation({
    mutationKey: ['start-poll', pollId],
    mutationFn: () => startPoll(pollId),
  })
}

export function useEndPollMutation(pollId: number) {
  return useMutation({
    mutationKey: ['end-poll', pollId],
    mutationFn: () => endPoll(pollId),
  })
}
